import authenticationApi from './auth';

const subscriptions = [];

const request = ({
	method, url, data, contentType, headers, disableSubscriptions
}) => {
	const promise = new Promise((resolve, reject) => {
        authenticationApi.getAccessToken().then((token) => {
            const authHeaders = headers || {};
            authHeaders.Authorization = `Bearer ${token}`;
            $.ajax({
				method, url, contentType, data, headers: authHeaders
			}).then(resolve)
			.catch((jqXHR) => {
				const errorMessage = jqXHR.responseText || 'OOPS, Something went wrong. Please try again later';
				return reject(errorMessage);
			});
		});
	});
	if (!disableSubscriptions) {
        _.each(subscriptions, subscription => subscription(promise));
	}
	return promise;
};

const requestWithJson = options => {
	const data = JSON.stringify(options.data);
	return request(_.defaults({ contentType: 'application/json', data }, options));
};
export const get = (url, data, headers) => request({
	method: 'GET', url, data, headers
});
export const search = (url, data, headers) => request({
	method: 'GET', url, data, headers, disableSubscriptions: true
});
export const post = (url, data) => requestWithJson({ method: 'POST', url, data });
export const put = (url, data) => requestWithJson({ method: 'PUT', url, data });
export const del = (url, data) => request({ method: 'DELETE', url, data });

export const subscribe = subscription => {
	const unsubscribe = () => {
		const index = subscriptions.indexOf(subscription);
		if (index >= 0) {
			subscriptions.splice(index, 1);
		}
	};
	subscriptions.push(subscription);
	return unsubscribe;
};
